import React from "react";

export const Loader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/5 backdrop-blur-sm">

      {/* Dots */}
      <div className="flex gap-3 mb-3">
        <div className="w-5 h-5 rounded-full bg-primary-500 animate-bounce [animation-delay:-0.3s]"></div>
        <div className="w-5 h-5 rounded-full bg-primary-500 animate-bounce [animation-delay:-0.15s]"></div>
        <div className="w-5 h-5 rounded-full bg-primary-500 animate-bounce"></div>
      </div>

      {/* Text */}
      <p className="text-sm text-white font-medium tracking-wide">
        Please wait...
      </p>

    </div>
  );
};
